import { Line } from './linesModels';
import i18n from '@/plugins/i18n';

export function toLineAutocompleteItem(line: Line) {
    const title = line.lineNumber === '0' ? i18n.global.t('shared.resources.common.all') : `${line.name} (${line.lineNumber})`;
    return { title: title === '' ? line.name : title, value: line.lineNumber, data: line };
}
